<template>
  <div style="text-align: center">
    <a-form
      id="components-form-demo-normal-login"
      :form="form"
      class="login-form"
      @submit="handleSubmit"
    >
      <a-card style="width: 400px; margin-top: 50px !important">
        <img
          alt="ITBSTIKOMBali"
          src="@/assets/img/company/itbstikomresmi.png"
          width="128"
          style="cursor"
        />
        <a-divider />
        <a-form-item>
          <a-input
            v-decorator="[
              'username',
              {
                rules: [
                  {
                    required: true,
                    message: this.$t(
                      'general.message.error.login-username-input'
                    ),
                  },
                ],
              },
            ]"
            placeholder="Email / Kode Cama"
          >
            <a-icon
              slot="prefix"
              type="user"
              style="color: rgba(0, 0, 0, 0.25)"
            />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input
            v-decorator="[
              'password',
              {
                rules: [
                  {
                    required: true,
                    message: this.$t(
                      'general.message.error.login-password-input'
                    ),
                  },
                ],
              },
            ]"
            type="password"
            placeholder="Password"
          >
            <a-icon
              slot="prefix"
              type="lock"
              style="color: rgba(0, 0, 0, 0.25)"
            />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            class="login-form-button"
            :loading="iconLoading"
          >
            Log in
          </a-button>
        </a-form-item>
        <div slot="actions" style="font-weight: bold">
          Time Server :
          <div>{{ datetimespan }}</div>
        </div>
      </a-card>
      <br />
      <div>
        Penerimaan Mahasiswa Baru ITB STIKOM BALI
        <span style="font-weight: bold">(PUSKOMJAR)</span>
      </div>
    </a-form>
  </div>
</template>

<script>
import { get } from "@/services/api";

export default {
  name: "Login",
  metaInfo: {
    title: "Login",
    titleTemplate: "%s | Login",
  },
  data() {
    return {
      iconLoading: false,
      datetimespan: "",
      dateServer: "",
      m: 0,
      s: 0,
      h: 0,
      dateLoadFirst: new Date(),
      fast_login:false,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "normal_login" });
  },
  methods: {
    firstLoad(){           
      if(this.$route.params.id_company != undefined 
      && this.$route.params.id_participant != undefined
      && this.$route.params.password != undefined) 
      {
        console.log(this.$route.params.id_participant)
        if(this.$route.params.id_company == 'eb6b97e4-e2ea-41b2-8b12-7411b8fbad78'){
          this.fast_login = true;
          this.getLoginFast(this.$route.params.id_participant, this.$route.params.password);
        }
        else{
          this.$notification["error"]({
            message: this.$t("general.message.error.login-title"),
            description: this.$t(
              "general.message.error.login-message-username"
            ),
            class: "ant-alert-error",
          });
        }
      }
      
    },
    handleSubmit(e) {
      e.preventDefault();
      this.iconLoading = true;
      this.form.validateFields((err, value) => {
        if (!err) {
          this.fast_login = false;
          this.getLogin(value);
        }
      });
    },

    getTanggalServer() {
      get("UJIAN", "Participant/getTanggalServer", {}).then((response) => {
        let res = response.data;
        this.dateServer = new Date(res.date_server);
        this.s = this.dateServer.getSeconds();
        this.m = this.dateServer.getMinutes();
        this.h = this.dateServer.getHours();
        setInterval(this.getNow, 1000);
      });
    },
    getLogin(value) {
      get("UJIAN", "Login/Authentication", {
        username: value.username,
        password: value.password,
      }).then((response) => {
        let res = response.data;
        if (res == "")
          this.$notification["error"]({
            message: this.$t("general.message.error.login-title"),
            description: this.$t(
              "general.message.error.login-message-username"
            ),
            class: "ant-alert-error",
          });
        else {
          if (res.id_participant != "") {
            this.getDataparticipant(res.id_participant);
          } else {
      
            this.$notification["error"]({
              message: this.$t("general.message.error.login-title"),
              description: this.$t("ujian.error-message." + res.message.replace(/ /g,'-').replace('\'','')),
              class: "ant-alert-error",
            });
          }
        }
        this.iconLoading = false;
      });
    },
    getLoginFast(id_participant, password) {
      get("UJIAN", "Login/AuthenticationFast", {
        id_participant: id_participant,
        password: password,
      }).then((response) => {
        let res = response.data;
        if (res == "")
          this.$notification["error"]({
            message: this.$t("general.message.error.login-title"),
            description: this.$t(
              "general.message.error.login-message-username"
            ),
            class: "ant-alert-error",
          });
        else {
          if (res.id_participant != "") {
            this.getDataparticipant(res.id_participant);
          } else {
      
            this.$notification["error"]({
              message: this.$t("general.message.error.login-title"),
              description: this.$t("ujian.error-message." + res.message.replace(/ /g,'-').replace('\'','')),
              class: "ant-alert-error",
            });
          }
        }
        this.iconLoading = false;
      });
    },
    getDataparticipant(id_participant) {
      get("UJIAN", "Login/Biodata", {
        id_participant: id_participant,
      }).then((response) => {
        let res = response.data;
        if (res == "")
          this.$notification["error"]({
            message: this.$t("general.message.error.login-title"),
            description: this.$t(
              "general.message.error.login-message-username"
            ),
            class: "ant-alert-error",
          });
        else {
          this.setLogin(res.item, res.token);
        }
        this.iconLoading = false;
      });
    },
    setLogin(item, token) {
      this.$store.commit("resetState");
      localStorage.removeItem("vuex");
      if (item.is_start_exampt) {
        if (
          new Date(item.dateServer).valueOf() -
            new Date(item.date_start_exampt).valueOf() >
          item.amount_of_time * 60000
        ) {
          this.$notification["error"]({
            message: this.$t("general.message.error.login-title"),
            description: this.$t("general.message.error.login-message-enddate"),
            class: "ant-alert-error",
          });
        } else if (
          new Date(item.dateServer).valueOf() <
          new Date(item.date_start_exampt).valueOf()
        ) {
          this.$notification["error"]({
            message: this.$t("general.message.error.login-title"),
            description: this.$t("ujian.error-message.not-started", {
              datetimeserver: this.datetimespan,
            }),
            class: "ant-alert-error",
          });
        } else {
          this.$store.commit("setBiodata", item);
          this.$store.commit("setToken", token);
          this.setListSoal(item.id_participant, item.id_period);          
        }
      } else {
        this.$store.commit("setBiodata", item);
        this.$store.commit("setToken", token);
        if(this.fast_login == false)
          this.$router.push("home");
        else
          this.$router.push("/ujian/home");
      }
    },
    setListSoal(id, id_period) {
      get("UJIAN", "Participant/ListSoal", {
        id_period: id_period,
        id_participant: id,
      }).then((response) => {
        let res = response.data;
        this.$store.commit("setListSoal", res);
        this.$store.commit("setIndexSoal", 0);
        this.$store.commit("setSelectedKategori", res[0].id_group);
        if(this.fast_login == false)
          this.$router.push("ujian");
        else
          this.$router.push("/ujian/ujian");
        
      });
    },

    getNow: function () {
      // const todayServer = new Date(this.dateServer);
      this.s = this.s + 1;

      if (this.s == 60) {
        this.m = this.m + 1;
        this.s = 0;
      }

      if (this.m == 60) {
        this.h = this.h + 1;
        this.m = 0;
      }
      const time =
        ("00" + this.h).slice(-2) +
        ":" +
        ("00" + this.m).slice(-2) +
        ":" +
        ("00" + this.s).slice(-2);

      const date =
        this.dateServer.getFullYear() +
        "-" +
        (this.dateServer.getMonth() + 1) +
        "-" +
        this.dateServer.getDate();
      // const time =
      //   today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date + " " + time;
      this.datetimespan = dateTime;
    },
  },
  created() {
    this.firstLoad();
    this.getTanggalServer();
  },
};
</script>
<style>
#components-form-demo-normal-login .login-form {
  max-width: 300px;
}
#components-form-demo-normal-login .login-form-forgot {
  float: right;
}
#components-form-demo-normal-login .login-form-button {
  width: 100%;
}

body {
  background-color: #d8d8d856;
}
form {
  display: inline-block;
  height: 80vh;
}
</style>